"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIgusGUId = void 0;
const createIgusGUId = (id, options = {}) => (Object.assign(Object.assign({ dirty: false, expired: false, exposed: false }, options), { id, creationTimestamp: new Date().getTime() }));
exports.createIgusGUId = createIgusGUId;
//# sourceMappingURL=IgusGUId.js.map